import {
    ONBOARDING_MAINTENANCE_ALERT_DEFAULT,
    type OnboardingMaintenanceAlertConfig,
} from "./types/onboardingMaintenanceAlert"

/**
 * Quote variant experiment values. Kept in this client-safe module so that both
 * the server-side flag definition and the onboarding form schema can derive
 * their types from a single source of truth.
 */
export enum QuoteVariant {
    HighInput = "high-input",
    LowInput = "low-input",
    LowInputCustomizable = "low-input-customizable",
}

/**
 * Client-safe feature flag contract.
 *
 * This module intentionally imports NO flag definitions (which pull in
 * server-only code via `flags/next` / `node:async_hooks`). It only holds the
 * value types and defaults, so it can be safely imported from client components
 * and the global `FeatureFlagsProvider`.
 *
 * The server-side registry in `feature-flags.ts` is `satisfies`-checked against
 * `FeatureFlagValues`, so adding/removing a flag there surfaces a type error
 * here until this contract is updated.
 */
export type FeatureFlagValues = {
    invoiceUpload: boolean
    onboardingMaintenanceAlert: OnboardingMaintenanceAlertConfig
    coconOffer: boolean
    wheelOfFortune: boolean
    prepayment: "meelo" | "gocardless"
}

export type FeatureFlagKey = keyof FeatureFlagValues

/**
 * Client-side fallback values, used when a page hasn't resolved the flags (or
 * before hydration). Keep in sync with each flag's server-side default.
 */
export const FEATURE_FLAG_DEFAULTS: FeatureFlagValues = {
    invoiceUpload: false,
    onboardingMaintenanceAlert: ONBOARDING_MAINTENANCE_ALERT_DEFAULT,
    coconOffer: false,
    wheelOfFortune: false,
    prepayment: "meelo",
}
